import Vue from 'vue'
import confirm from '@/components/confirmation-modal/confirm.vue'
import { mapState } from 'vuex'
export default Vue.extend({
  name: 'Complete',
  components: {
    confirm
  },
  computed: {
    ...mapState(['contact'])
  },
  mounted() {
    if (!this.contact.isComplete) {
      this.$router.push('/contact')
    }
  }
})
